(function () {
  "use strict";
  window.rqbReady = true;
  var TIERS = [[12, "12–23"], [24, "24–49"], [50, "50–99"], [100, "100–249"], [250, "250–499"], [500, "500+"]];
  var HOSTS = [
    { id: "home", el: function () { return q(".rva-bl__band .rva-bl__bar"); },
      keys: "#rvaBlQty [data-q]", input: "#rvaBlQtyIn", fStep: "#rvaBlInk", fVal: "#rvaBlInkVal",
      bOn: "#rvaBlBackOn", bStep: "#rvaBlBack", bVal: "#rvaBlBackVal", nudge: "#rvaBlNudge" },
    { id: "style", el: function () { return q("#rvaCat.rva-style-page") ? q("#pQtyEdit") : null; },
      keys: "#pKeys [data-q]", input: "#qty", fStep: "#pFrontStep", fVal: "#pFrontVal",
      bOn: "#pBackOn", bStep: "#pBackStep", bVal: "#pBackVal" },
    { id: "cat", el: function () { return q("#rvaCat.rva-style-page") || q("#reqPage") ? null : q("#bar .barIn"); },
      keys: "#keys [data-q]", input: "#qty", fStep: "#frontStep", fVal: "#frontVal",
      bOn: "#backOn", bStep: "#backStep", bVal: "#backVal", nudge: "#bar .barNudge", copy: "#barCopy" }
  ];
  var PEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L18.5 9.5a2.83 2.83 0 0 0-4-4L4 16v4"/><path d="M13.5 6.5l4 4"/></svg>';

  function q(s, r) { return (r || document).querySelector(s); }
  function num(t) { var m = String(t == null ? "" : t).match(/\d+/); return m ? +m[0] : 0; }
  function tierIx(n) { for (var i = TIERS.length - 1; i >= 0; i--) if (n >= TIERS[i][0]) return i; return 0; }
  function colors(n) { return n + "-color"; }
  function money(n) { return "$" + n.toFixed(2); }
  function setHTML(node, html) { if (node && node.getAttribute("data-h") !== html) { node.innerHTML = html; node.setAttribute("data-h", html); } }
  function press(el) { if (el && !el.disabled) el.click(); }
  function fixed() { return !!host && host.id === "style" && typeof window.rvaQtyNow === "function"; }

  var host = null, ui = null, typing = false, typeTimer = 0, lastVal = "";

  var opt = null, todo = [], flushing = false, MAXF = 8, MAXB = 8;

  function markup() {
    return '<div class="rqb-in">' +
        '<div class="rqb-q">' +
          '<span class="rqb-lbl" id="rqbQL">Price tier · total order size <small>more pieces, lower price each</small></span>' +
          '<div class="rqb-qrow">' +
            '<div class="rqb-tiers" role="radiogroup" aria-labelledby="rqbQL">' +
              TIERS.map(function (t, i) {
                return '<button type="button" role="radio" aria-checked="false" data-t="' + i + '">' + t[1] + "</button>";
              }).join("") +
            "</div>" +
            '<label class="rqb-exact"><span class="rqb-or">or</span><span class="rqb-box">' +
              '<input type="number" min="12" max="5000" step="1" inputmode="numeric" aria-label="Type your exact total, 12 or more">' + PEN +
            "</span></label>" +
          "</div>" +
        "</div>" +
        '<div class="rqb-f"><span class="rqb-lbl">Front print</span>' +
          '<div class="rqb-step"><button type="button" data-s="f" data-d="-1" aria-label="One fewer front ink color">−</button><output aria-live="polite"></output><button type="button" data-s="f" data-d="1" aria-label="One more front ink color">+</button></div></div>' +
        '<div class="rqb-b"><span class="rqb-lbl">Back print</span>' +
          '<div class="rqb-step"><button type="button" data-s="b" data-d="-1" aria-label="One fewer back ink color">−</button><output aria-live="polite"></output><button type="button" data-s="b" data-d="1" aria-label="One more back ink color">+</button></div></div>' +
        '<div class="rqb-sum"><p class="rqb-say" aria-live="polite"></p><div class="rqb-end"><p class="rqb-nudge" hidden></p><span class="rqb-copy"></span></div></div>' +
      "</div>";
  }

  function build() {

    var d = document.getElementById("rqb");
    if (d && (d.rqbWired || d.getAttribute("data-host") !== host.id)) {
      if (!d.rqbWired && d.parentNode) d.parentNode.removeChild(d);
      d = null;
    }
    if (!d) {
      d = document.createElement("div");
      d.className = "rqb";
      d.id = "rqb";
      d.setAttribute("data-host", host.id);
      d.innerHTML = markup();
    }
    d.rqbWired = true;
    d.addEventListener("click", onClick);
    var inp = q("input", d);
    inp.addEventListener("focus", function () { typing = true; try { inp.select(); } catch (e) {} });
    inp.addEventListener("input", function () {
      lastVal = inp.value;
      clearTimeout(typeTimer);

      if (host && host.id === "style") return;
      typeTimer = setTimeout(function () { if (num(inp.value) >= 12) setQty(num(inp.value)); }, 450);
    });
    inp.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); inp.blur(); } });
    inp.addEventListener("blur", function () {
      clearTimeout(typeTimer);
      setTimeout(function () {
        if (document.activeElement && ui && q("input", ui) === document.activeElement) return;
        typing = false;
        var v = num(inp.value);
        setQty(Math.max(12, Math.min(5000, v || state().qty)));
        sync();
      }, 0);
    });
    return d;
  }

  function limits(s) {
    s.fMinus = s.front <= (s.on ? 0 : 1);
    s.fPlus = s.front >= MAXF;
    s.bPlus = s.on && s.back >= MAXB;
    return s;
  }
  function state() {
    if (opt) return opt;
    var inp = q(host.input), S = window.S || {};
    var qty = inp ? num(inp.value) : 0;
    if (!qty) qty = +S.qty || 0;
    if (!qty) { var k = q(host.keys + '[aria-pressed="true"]'); qty = k ? num(k.getAttribute("data-q")) : 12; }
    if (fixed()) qty = num(window.rvaQtyNow()) || qty;
    var bOn = q(host.bOn), on = !!bOn && bOn.getAttribute("aria-pressed") === "true";
    var fs = q(host.fStep), bs = q(host.bStep);
    var fMinus = fs && q('[data-d="-1"]', fs), fPlus = fs && q('[data-d="1"]', fs), bPlus = bs && q('[data-d="1"]', bs);
    var s = {
      qty: Math.max(12, qty),
      front: num((q(host.fVal) || {}).textContent),
      back: on ? Math.max(1, num((q(host.bVal) || {}).textContent)) : 0,
      on: on,
      fMinus: !fMinus || fMinus.disabled,
      fPlus: !fPlus || fPlus.disabled,
      bPlus: on ? (!bPlus || bPlus.disabled) : !bOn
    };

    if (s.fPlus && fPlus && s.front) MAXF = s.front;
    if (on && s.bPlus && bPlus) MAXB = s.back;
    return s;
  }

  function nudge(s) {
    var i = tierIx(s.qty);
    if (i >= TIERS.length - 1) return null;
    var next = TIERS[i + 1][0];
    if (typeof window.tierFor === "function" && typeof window.printCost === "function") {
      try {
        var a = window.printCost(window.tierFor(s.qty), s.front, s.back, 0);
        var b = window.printCost(window.tierFor(next), s.front, s.back, 0);
        if (a - b > 0.004) return { amt: money(a - b), at: next };
        return null;
      } catch (e) {}
    }
    var n = host.nudge && q(host.nudge);
    if (n && /\$\d/.test(n.textContent)) {
      var m = n.textContent.match(/\$\d+(?:\.\d+)?/), go = q("[data-q]", n);
      return { amt: m[0], at: go ? num(go.getAttribute("data-q")) : next };
    }
    return null;
  }

  function sync() {
    if (!ui || !host) return;
    var s = state(), ix = tierIx(s.qty);
    Array.prototype.forEach.call(ui.querySelectorAll(".rqb-tiers button"), function (b) {
      var on = String(+b.getAttribute("data-t") === ix);
      if (b.getAttribute("aria-checked") !== on) b.setAttribute("aria-checked", on);
    });
    var inp = q("input", ui);
    if (!typing && inp.value !== String(s.qty)) inp.value = s.qty;

    var f = q(".rqb-f output", ui), b = q(".rqb-b output", ui);
    var ft = s.front ? s.front + (s.front > 1 ? " colors" : " color") : "None";
    var bt = s.back ? s.back + (s.back > 1 ? " colors" : " color") : "None";
    if (f.textContent !== ft) f.textContent = ft;
    if (b.textContent !== bt) b.textContent = bt;
    if (f.classList.contains("rqb-none") !== !s.front) f.classList.toggle("rqb-none", !s.front);
    if (b.classList.contains("rqb-none") !== !s.back) b.classList.toggle("rqb-none", !s.back);
    dis(q('.rqb-f [data-d="-1"]', ui), s.fMinus);
    dis(q('.rqb-f [data-d="1"]', ui), s.fPlus);
    dis(q('.rqb-b [data-d="-1"]', ui), !s.on);
    dis(q('.rqb-b [data-d="1"]', ui), s.bPlus);

    var spec = s.front && s.back ? colors(s.front) + " front, " + colors(s.back) + " back"
      : s.front ? colors(s.front) + " front" : colors(s.back) + " back";
    setHTML(q(".rqb-say", ui), "Prices are each, garment and printing · <b>" + s.qty + " pieces</b> · <b>" +
      TIERS[ix][1] + "</b> tier · <b>" + spec + "</b>");
    var n = nudge(s), ne = q(".rqb-nudge", ui), fx = fixed();
    if (fx) {
      Array.prototype.forEach.call(ui.querySelectorAll(".rqb-tiers button"), function (b) {
        if (b.getAttribute("tabindex") !== "-1") { b.setAttribute("tabindex", "-1"); b.setAttribute("aria-disabled", "true"); }
      });
    }
    if (fx && typeof window.rvaQtyTyped === "function" && !window.rvaQtyTyped()) {
      var rq = typeof window.rvaQtyReq === "function" ? num(window.rvaQtyReq()) : 0;
      setHTML(ne, rq > 0 && rq >= s.qty ? "Priced with the <b>" + rq + " pieces</b> in your request." : "Showing <b>" + s.qty + "-piece</b> pricing until you enter your sizes.");
      if (ne.hidden) ne.hidden = false;
    } else if (n) {
      setHTML(ne, "Pricing drops <b>" + n.amt + "</b>/piece at " + (fx ? "<b>" + n.at + " pieces</b>" :
        '<button type="button" class="rqb-go" data-at="' + n.at + '">' + n.at + " pieces</button>"));
      if (ne.hidden) ne.hidden = false;
    } else if (!ne.hidden) ne.hidden = true;

    if (host.copy) {
      var c = q(host.copy), slot = q(".rqb-copy", ui);
      if (c && slot && c.parentNode !== slot) {
        var ph = q("[data-rqb-ph]", slot);
        if (ph) slot.removeChild(ph);
        slot.appendChild(c);
      }
    }
  }
  function dis(el, v) { if (el && el.disabled !== !!v) el.disabled = !!v; }

  function afterPaint(fn) {
    var done = false;
    function go() { if (!done) { done = true; fn(); } }
    if (document.hidden || !window.requestAnimationFrame) { setTimeout(go, 0); return; }
    requestAnimationFrame(function () { setTimeout(go, 0); });
    setTimeout(go, 120);
  }
  function later(next, action) {
    opt = limits(next);
    sync();
    todo.push(action);
    if (flushing) return;
    flushing = true;
    afterPaint(function () {
      var list = todo;
      todo = [];
      flushing = false;
      for (var i = 0; i < list.length; i++) { try { list[i](); } catch (e) {} }
      opt = null;
      soon();
    });
  }
  function copyOf(s) { return { qty: s.qty, front: s.front, back: s.back, on: s.on }; }

  function applyQty(n) {
    var inp = q(host.input);
    if (inp) {
      if (num(inp.value) !== n) {
        inp.value = n;
        inp.dispatchEvent(new Event("input", { bubbles: true }));
        inp.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (host.id === "style" && window.S && +window.S.qty !== n) press(q(host.keys + '[data-q="' + TIERS[tierIx(n)][0] + '"]'));
    } else {
      press(q(host.keys + '[data-q="' + TIERS[tierIx(n)][0] + '"]'));
    }
  }
  function setQty(n) {
    n = Math.max(12, Math.min(5000, n));
    var s = copyOf(state());
    s.qty = n;
    later(s, function () { applyQty(n); });
  }

  function onClick(e) {
    var t = e.target.closest("button");
    if (!t || !ui.contains(t) || t.disabled) return;
    if (t.hasAttribute("data-t")) {
      if (fixed()) return;
      typing = false;
      var want = TIERS[+t.getAttribute("data-t")][0], s0 = copyOf(state());
      s0.qty = want;
      later(s0, function () {
        var key = q(host.keys + '[data-q="' + want + '"]');
        if (key) press(key); else applyQty(want);
      });
      return;
    }
    if (t.classList.contains("rqb-go")) { if (fixed()) return; typing = false; setQty(+t.getAttribute("data-at")); return; }
    var side = t.getAttribute("data-s"), d = t.getAttribute("data-d");
    if (!side) return;
    var s = state(), n = copyOf(s);
    if (side === "f") {
      if (d === "1") { if (s.fPlus) return; n.front++; } else { if (s.fMinus) return; n.front--; }
      later(n, function () { press(q('[data-d="' + d + '"]', q(host.fStep))); });
    } else if (d === "1") {
      if (!s.on) {
        n.on = true; n.back = 1;
        later(n, function () { press(q(host.bOn)); });
      } else {
        if (s.bPlus) return;
        n.back++;
        later(n, function () { press(q('[data-d="1"]', q(host.bStep))); });
      }
    } else if (s.on) {
      if (s.back <= 1) {
        n.on = false; n.back = 0;
        if (!n.front) n.front = 1;
        later(n, function () { press(q(host.bOn)); });
      } else {
        n.back--;
        later(n, function () { press(q('[data-d="-1"]', q(host.bStep))); });
      }
    }
  }

  function mount() {
    var el = null;
    host = null;
    for (var i = 0; i < HOSTS.length; i++) { el = HOSTS[i].el(); if (el) { host = HOSTS[i]; break; } }
    if (!host) return false;
    if (!ui || ui.getAttribute("data-host") !== host.id) ui = build();

    if (ui.previousElementSibling !== el || ui.parentNode !== el.parentNode) {
      var had = typing && document.activeElement === q("input", ui);
      el.parentNode.insertBefore(ui, el.nextSibling);
      if (had) { var inp = q("input", ui); inp.focus(); inp.value = lastVal; }
    }
    var ord = window.getComputedStyle(el).order;
    if (ui.style.order !== ord) ui.style.order = ord;
    if (!document.documentElement.classList.contains("rqb-on")) document.documentElement.classList.add("rqb-on");
    return true;
  }

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    var run = function () { queued = false; try { if (mount()) sync(); } catch (e) {} };

    if (window.Promise) Promise.resolve().then(run); else setTimeout(run, 0);
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest(".tEdit")) setTimeout(function () { var i = ui && q("input", ui); if (i) i.focus(); }, 420);
  }, true);

  function start() {
    soon();
    if ("MutationObserver" in window) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) if (!ui || !ui.contains(list[i].target)) { soon(); return; }
      }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["aria-pressed", "disabled"] });
    }
    document.addEventListener("input", function (e) { if (!ui || !ui.contains(e.target)) soon(); }, true);
    window.addEventListener("pageshow", soon);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
